const SUBGRAPH_DOMAIN = `https://subgraphs.pdex.vision`

/**
 * V1 will be deprecated but is still used to claim old rounds
 */
export const STATS_SUBGRAPH_CLIENT = `${SUBGRAPH_DOMAIN}/subgraphs/name/stats`
export const BLOCKS_CLIENT_PULSE = `${SUBGRAPH_DOMAIN}/subgraphs/name/blocks`
// export const V2_SUBGRAPH_CLIENT = `${SUBGRAPH_DOMAIN}/subgraphs/name/v2`
export const V3_SUBGRAPH_CLIENT = `${SUBGRAPH_DOMAIN}/subgraphs/name/exchange`
export const STABLESWAP_SUBGRAPH_CLIENT = `${SUBGRAPH_DOMAIN}/subgraphs/name/exchange`
export const DCA_ORDERS_CLIENT_PULSECHAIN = `${SUBGRAPH_DOMAIN}/subgraphs/name/orders`
export const ORDERS_CLIENT_PULSECHAIN = `${SUBGRAPH_DOMAIN}/subgraphs/name/orders`
